cv.PayAmountView = Marionette.LayoutView.extend({
  className: 'view-pay-amount',

  template: cv.Templates['pay/amount/pay_amount'],

  regions: {
  },

  payModelBinding : {
    ':el' : {
      observe : ['recipient', 'recipient_menu'],
      update: function($el, value, model, options){
        if(!_.isNull(model.get('recipient'))){
          $el.find('.recipient-assigned').hide();
          $el.find('.open-recipient-list').hide();
          $el.find('.close-recipient-list').hide();
          $el.find('.recipient-select').hide();

          var interval = setInterval(_.bind(function(){
            if(cv.pay.get('recipient_loaded') == true){
              // Clear the interval
              clearInterval(interval);

              $el.find('.recipient-assigned').html(cv.Templates['pay/amount/recipient']({
                name : cv.pay.get('recipient').name,
                stub : cv.pay.get('recipient').stub,
                photo : cv.pay.get('recipient').photo,
              }));

              $el.find('.recipient-assigned').fadeIn();

              if($el.find('.imgix-fluid').length > 0){
                imgix.fluid($el.get(0), {
                  updateOnResizeDown: false,
                  pixelStep: 5,
                  autoInsertCSSBestPractices: true
                });
              }

              if(cv.pay.get('iframe_type') == 'embed'){
                vent.trigger('pay:recalculate_iframe');
              }
            }
          }, this), 100);

          return;
        }

        if(model.get('recipient_menu') == true){
          $el.find('.recipient-assigned').hide();
          $el.find('.open-recipient-list').hide();
          $el.find('.close-recipient-list').show();
          $el.find('.recipient-select').fadeIn();

          // Hack to get all to show
          setTimeout(function(){
            $el.find('#recipient').focus();
          }, 500);
        }else{
          $el.find('.recipient-assigned').hide();
          $el.find('.open-recipient-list').show();
          $el.find('.close-recipient-list').hide();
          $el.find('.recipient-select').hide();
        }
        if(cv.pay.get('iframe_type') == 'embed'){
          vent.trigger('pay:recalculate_iframe');
        }
      }
    },
    '.recipient-filter' : {
      observe : ['recipient_filter'],
      update: function($el, value, model, options){
        $el.find('a').removeClass('active');

        if(model.get('recipient_filter') == 'all'){
          $el.find('.filter-all').addClass('active');
        }
        if(model.get('recipient_filter') == 'fundraisers'){
          $el.find('.filter-fundraisers').addClass('active');
        }
        if(model.get('recipient_filter') == 'teams'){
          $el.find('.filter-teams').addClass('active');
        }
      }
    }
  },

  bindings : {
    ':el' : {
      observe : ['recurring'],
      update: function($el, value, model, options) {
        $el.find('.period').removeClass('active');
        if(model.get('recurring') == 1){
          $el.find('.period-recurring').addClass('active');
          $el.find('.tier-one_time').hide();
          $el.find('.tier-recurring').show();
        }else{
          $el.find('.period-single').addClass('active');
          $el.find('.tier-one_time').show();
          $el.find('.tier-recurring').hide();
        }
      }
    },
    '.tiers' : {
      observe : ['amount'],
      update: function($el, value, model, options) {
        $el.find('.tier').removeClass('active');

        if(model.get('amount') > 0) {
          // Convert to string to remove any trailing zeros
          // If we find the proper tier then highlight it
          if($el.find('.tier[data-amount="' + model.get('amount') + '"]').length > 0){
            $el.find('.tier[data-amount="' + model.get('amount') + '"]').addClass('active');

          // Otherwise we highlight the last tier
          } else {
            $el.find('.tier:last').addClass('active');
          }
        }else{
          $el.find('.tier:last').addClass('active');
        }
      }
    },
    '.form-tipping' : {
      observe : ['tip_percent'],
      update: function($el, value, model, options) {
        if(this.use_cv_tip == true){
          if(model.get('tip_percent') == 'other'){
            $el.find('.tipping__custom').show();
          }else{
            $el.find('.tipping__custom').hide();
          }
        }else{
          $el.find('.tipping__percent').hide();
          $el.find('.tipping__custom').show();
        }

        if(cv.pay.get('iframe_type') == 'embed'){
          vent.trigger('pay:recalculate_iframe');
        }
      }
    }
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications: true
  }],

  validation: {
    custom_amount: [{
      required: function(){
        if(this._model_clone.get('amount') != this._model_clone.get('custom_amount')){
          return false;
        }
        return true;
      },
      msg: ' '
    },{
      min: 1,
      msg: ' '
    }],
    tip: [],
    tip_percent: [],
    add_tip: []
  },

  events: {
    'click .period' : 'selectPeriod',
    'click .tier' : 'selectTier',
    'blur #custom_amount' : 'blurCustomAmount',
    'focus #tip' : 'focusTipAmount',
    'blur #tip' : 'blurTipAmount',
    'click .open-recipient-list' : 'selectRecipient',
    'click .remove-recipient, .close-recipient-list' : 'removeRecipient',
    'click .filter-button' : 'switchFilter'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.model = cv.pay;

    // Tip behavior changes based on starter plan
    this.use_cv_tip = cv.campaign.get('organization.plan') == 'starter' || cv.campaign.get('enable_cv_tip') == 1 ? true : false;
    var zero_decimal_currencies = [
      'BIF',
      'CLP',
      'DJF',
      'GNF',
      'JPY',
      'KMF',
      'KRW',
      'MGA',
      'PYG',
      'RWF',
      'UGX',
      'VND',
      'VUV',
      'XAF',
      'XOF',
      'XPF'
    ];
    if(zero_decimal_currencies.indexOf(cv.campaign.get('currency_code')) === -1){
      this.decimal_places = 2;
    }else{
      this.decimal_places = 0;
    }


    // Tip calculation helper var
    this.previous_tip_value = 0;

    // Bind model change to local storage but preserve project and team IDs
    this.listenTo(this._model_clone, 'change', function(model){
      var update_data = _.extend(model.attributes);
      update_data.project_id = cv.pay.get('project_id');
      update_data.team_id = cv.pay.get('team_id');
      vent.trigger('pay:save_cart', update_data);
    }, this);

    this.listenTo(this, 'form:saved', function(){
      vent.trigger('pay:next_screen');
    }, this);

    // When the amount changes, check if we are on the other amount
    this.listenTo(this._model_clone, 'change:amount', function(model){
      // If tipping is disabled we set it to zero
      if(cv.campaign.get('enable_tipping') == 0 && this.use_cv_tip == false){
        this.trigger('form:set','tip', 0);
        return;
      }

      // If we are on a starter plan and the default tip percents, then set the tip to the percent amount
      if(this.use_cv_tip == true && model.get('tip_percent') != 'other'){
        this.trigger('form:set','tip', accounting.toFixed(accounting.unformat(model.get('tip_percent') * model.get('amount')), this.decimal_places));
      // If the tip has not been set already, then change the tip amount with tier or custom amount changes
      }
      if(this.use_cv_tip == true && model.get('tip_percent') == 'other'){
        // Set to recommended tip amount
        if(model.get('tip_changed') == false){
          this.trigger('form:set','tip', accounting.toFixed(accounting.unformat(cv.campaign.get('tip_percent')/100 * model.get('amount')), this.decimal_places));
        }
      }
      if(this.use_cv_tip != true){
        if(model.get('add_tip') == 1){
          this.trigger('form:set','tip', accounting.toFixed(accounting.unformat(cv.campaign.get('tip_percent')/100 * model.get('amount')), this.decimal_places));
        }else{
          this.trigger('form:set','tip', 0);
        }
      }

      console.log(model.attributes);
    }, this);

    // For the checkbox
    this.listenTo(this._model_clone, 'change:add_tip', function(model){
      if(this.use_cv_tip != true){
        if(model.get('add_tip') == 1){
          this.trigger('form:set','tip', accounting.toFixed(accounting.unformat(cv.campaign.get('tip_percent')/100 * model.get('amount')), this.decimal_places));
        }else{
          this.trigger('form:set','tip', 0);
        }
      }
    }, this);

    // When tip percent changes then change the actual tip
    this.listenTo(this._model_clone, 'change:tip_percent', function(model){
      // If tipping is disabled we set it to zero
      if(cv.campaign.get('enable_tipping') == 0 && this.use_cv_tip == false){
        this.trigger('form:set','tip', 0);
        return;
      }

      // If we are not in a starter plan, then just exit out of any additional logic
      if(this.use_cv_tip == false){
        return;
      }

      // If we specify another tip percent then set it to 0 to start out with, otherwise set it to the percent amount
      if(model.get('tip_percent') == 'other'){
        // Set to recommended tip amount (8%)
        if(model.get('tip_changed') == false){
          this.trigger('form:set','tip', accounting.toFixed(accounting.unformat(.1 * model.get('amount')), this.decimal_places));
        }
      }else{
        var tip_raw = model.get('amount') * model.get('tip_percent');
        this.trigger('form:set','tip', accounting.toFixed(accounting.unformat(tip_raw), this.decimal_places));
      }

      console.log(model.attributes);
    }, this);

    this.listenTo(this, 'form:has_errors', function(){
      vent.trigger('notif:error', 'Please choose a valid amount.');
    }, this);
    this.listenTo(vent, 'pay:next_button', this.next, this);

    console.log('PayAmountView initialized');
  },

  templateHelpers: function () {
    var tiers = [];
    _.each(cv.campaign.get('tiers'), function(item){
      item.amount = accounting.toFixed(accounting.unformat(item.amount), 2);
      tiers.push(item);
    }, this);

    var recurring_tiers = [];
    _.each(cv.campaign.get('recurring_tiers'), function(item){
      item.amount = accounting.toFixed(accounting.unformat(item.amount), 2);
      recurring_tiers.push(item);
    }, this);

    return {
      use_cv_tip : this.use_cv_tip,
      enable_compact_tiers : !!+cv.campaign.get('enable_compact_tiers'),
      campaign_title : cv.campaign.get('title'),
      currency_code : cv.campaign.get('currency_code'),
      tiers : tiers,
      recurring_tiers : recurring_tiers,
      enable_recurring : !!+cv.campaign.get('enable_recurring'),
      recurring_default : !!+cv.campaign.get('recurring_default'),
      recurring_mandatory : !!+cv.campaign.get('recurring_mandatory'),
      enable_tipping : !!+cv.campaign.get('enable_tipping'),
      tip_percent : cv.campaign.get('tip_percent'),
      enable_projects : !!+cv.campaign.get('enable_projects'),
      enable_teams : !!+cv.campaign.get('enable_teams')
    };
  },

  selectPeriod: function(e){
    e.preventDefault();

    if(this._model_clone.get('recurring') == 1 && $(e.currentTarget).hasClass('period-single')){
      this.trigger('form:set','recurring', 0);
    }
    if(this._model_clone.get('recurring') == 0 && $(e.currentTarget).hasClass('period-recurring')){
      this.trigger('form:set','recurring', 1);
    }
    if(this._model_clone.get('recurring') == 1 && $(e.currentTarget).hasClass('period-recurring')){
      return;
    }
    if(this._model_clone.get('recurring') == 0 && $(e.currentTarget).hasClass('period-single')){
      return;
    }

    // If we a have a custom amount, then leave it
    if(this.$('.tier:last').hasClass('active')){
      return false;
    }

    // When we toggle periods, check if the current amount is equal to a tier that exists in the other period
    if(this._model_clone.get('amount') > 0){
      // This is after we switch, so we reverse the test
      if(this._model_clone.get('recurring') == 0){
        var amounts = _.pluck(cv.campaign.get('tiers'),'amount');

        // If the amount does not in the tier set, then click the first tier
        if(_.indexOf(amounts, this._model_clone.get('amount')) === -1){
          this.$('.tier:visible:eq(0)').click();
        }
      }else{
        var amounts = _.pluck(cv.campaign.get('recurring_tiers'),'amount');

        // If the amount does not in the tier set, then click the first tier
        if(_.indexOf(amounts, this._model_clone.get('amount')) === -1){
          this.$('.tier:visible:eq(0)').click();
        }
      }
    }else{
      this.$('.tier:visible:eq(0)').click();
    }

    this.$('.tiers').hide().fadeIn();
  },

  selectTier: function(e){
    e.preventDefault();

    // If we already clicked it do nothing
    if($(e.currentTarget).hasClass('active')){
      return false;
    }

    // If we are clicking the last tier then set the amount and focus it
    if($(e.currentTarget).data('amount') === undefined){
      this.$('#custom_amount').focus();
      return false;
    }

    // If we clicked a valid tier then clear the custom box and set amount to that tier
    var amount = $(e.currentTarget).data('amount');
    if(!_.isUndefined(amount)){
      this.trigger('form:set','amount', accounting.toFixed(accounting.unformat(amount), 2));
      this.trigger('form:set','custom_amount', '');
    }
  },

  blurCustomAmount: function(e){
    e.preventDefault();

    // If we have a blank value then do nothing
    if($(e.currentTarget).val() != ''){
      this.trigger('form:set','custom_amount', accounting.toFixed(accounting.unformat($(e.currentTarget).val()), 2));
      this.trigger('form:set','amount', accounting.toFixed(accounting.unformat($(e.currentTarget).val()), 2));
    }
  },

  removeRecipient: function(e){
    e.preventDefault();

    // If we are clicking the close list, just close menu
    if($(e.currentTarget).hasClass('close-recipient-list')){
      cv.pay.set('recipient_menu', false);
      return;
    }

    // Otherwise we are clearing the recipient which will trigger close menu in callback
    cv.pay.set({
      'project_id': null,
      'team_id' : null
    });

    // Clear the text input
    this.$('#recipient').typeahead('val', '').blur();
  },

  switchFilter: function(e){
    e.preventDefault();

    if($(e.currentTarget).hasClass('filter-all')){
      cv.pay.set('recipient_filter', 'all');
    }
    if($(e.currentTarget).hasClass('filter-fundraisers')){
      cv.pay.set('recipient_filter', 'fundraisers');
    }
    if($(e.currentTarget).hasClass('filter-teams')){
      cv.pay.set('recipient_filter', 'teams');
    }

    // We have to set this first
    this.$('#recipient').typeahead('val','clear').trigger('change');

    // Then clear it back
    this.$('#recipient').typeahead('val','').trigger('change');

    // Scroll the list up
    this.$('.recipient-list').scrollTop(0);
  },

  focusTipAmount: function(e){
    // Set previous tip value
    this.previous_tip_value = $(e.currentTarget).val();
  },

  blurTipAmount: function(e){
    // If we have a blank value then do nothing, otherwise format the inputted tip
    if($(e.currentTarget).val() != ''){
      this.trigger('form:set','tip', accounting.toFixed(accounting.unformat($(e.currentTarget).val()), 2));
    }

    // If the changed amount is not equal to the previous tip value, then we flag tip changed
    if(this.previous_tip_value != accounting.toFixed(accounting.unformat($(e.currentTarget).val()), 2)){
      this.trigger('form:set','tip_changed', true);
    }
  },

  next: function(){
    this.trigger('form:save');
  },

  selectRecipient: function(e){
    e.preventDefault();

    if(cv.pay.get('recipient_menu') == false){
      cv.pay.set('recipient_menu', true);
    }else{
      cv.pay.set('recipient_menu', false);
    }
  },

  bindRecipients: function(){
    // If p2p isn't enabled, we don't bind anything
    if(cv.campaign.get('enable_projects') == 0){
      return;
    }

    // Set the filter to all by default and close the menu
    cv.pay.set('recipient_menu', false);
    cv.pay.set('recipient_filter', 'all');

    // Set the Options for "Bloodhound" suggestion engine
    var fundraiser_engine = new Bloodhound({
      prefetch : {
        url: cv.api_path + '/projects?limit=5000&include=id,user,display_name,stub&api_key=' + cv.PRELOADED.public_api_key + '&campaign_id=' + cv.campaign.get('id'),
        cache : false,
        transform : function(response){
          return $.map(response.data, function (data) {
            return {
              id : data.id,
              photo_path : data.user.photo_path,
              photo : cv.photo({
                photo_path : data.user.photo_path,
                photo_default : cv.campaign.get('default_fundraiser_photo'),
                url_only : false,
                transforms : {
                  w : 45,
                  h : 45,
                  fit : 'crop'
                },

              }),
              name : data.display_name,
              stub : data.stub,
              type : 'fundraiser'
            };
          });
        }
      },
      identify : function(datum){
        return 'fundraiser_' + datum.id;
      },
      datumTokenizer: function(d){
        var tokens = [];

        //the available string is 'name' in your datum
        var stringSize = d.name.length;
        //multiple combinations for every available size
        //(eg. dog = d, o, g, do, og, dog)
        for (var size = 1; size <= stringSize; size++){
          for (var i = 0; i+size<= stringSize; i++){
            tokens.push(d.name.substr(i, size));
          }
        }

        //the available string is 'name' in your datum
        var stringSize = d.stub.length;
        //multiple combinations for every available size
        //(eg. dog = d, o, g, do, og, dog)
        for (var size = 1; size <= stringSize; size++){
          for (var i = 0; i+size<= stringSize; i++){
            tokens.push(d.stub.substr(i, size));
          }
        }

        return tokens;
      },
      queryTokenizer: Bloodhound.tokenizers.whitespace
    });

    if(cv.campaign.get('enable_teams') == 1) {
      var team_engine = new Bloodhound({
        prefetch: {
          url: cv.api_path + '/teams?limit=5000&include=id,photo_path,name,stub&api_key=' + cv.PRELOADED.public_api_key + '&campaign_id=' + cv.campaign.get('id'),
          cache: false,
          transform: function (response) {
            return $.map(response.data, function (data) {
              return {
                id: data.id,
                photo_path: data.photo_path,
                photo: cv.photo({
                  photo_path: data.photo_path,
                  photo_default: cv.campaign.get('default_team_photo'),
                  url_only: false,
                  transforms: {
                    w: 45,
                    h: 45,
                    fit: 'crop'
                  },

                }),
                name: data.name,
                stub: 'team/' + data.stub,
                type: 'team'
              };
            });
          }
        },
        identify: function (datum) {
          return 'team_' + datum.id;
        },
        datumTokenizer: function (d) {
          var tokens = [];

          //the available string is 'name' in your datum
          var stringSize = d.name.length;
          //multiple combinations for every available size
          //(eg. dog = d, o, g, do, og, dog)
          for (var size = 1; size <= stringSize; size++) {
            for (var i = 0; i + size <= stringSize; i++) {
              tokens.push(d.name.substr(i, size));
            }
          }

          //the available string is 'name' in your datum
          var stringSize = d.stub.length;
          //multiple combinations for every available size
          //(eg. dog = d, o, g, do, og, dog)
          for (var size = 1; size <= stringSize; size++) {
            for (var i = 0; i + size <= stringSize; i++) {
              tokens.push(d.stub.substr(i, size));
            }
          }

          return tokens;
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace
      });
    }

    this.$('#recipient')
    .typeahead({
      minLength: 0,
      menu: this.$('.recipient-list')
    },{
      limit: 1000,
      source: function (q, sync) {
        // Fetch the results
        var results = [];
        if (q === '') {
          if(cv.pay.get('recipient_filter') == 'all' || cv.pay.get('recipient_filter') == 'fundraisers') {
            results = _.union(results, fundraiser_engine.all());
          }
          if(cv.campaign.get('enable_teams') == 1 && (cv.pay.get('recipient_filter') == 'all' || cv.pay.get('recipient_filter') == 'teams')){
            results = _.union(results,team_engine.all());
          }
        } else {
          if(cv.pay.get('recipient_filter') == 'all' || cv.pay.get('recipient_filter') == 'fundraisers') {
            fundraiser_engine.search(q, function (datums) {
              results = _.union(results, datums);
            });
          }
          if(cv.campaign.get('enable_teams') == 1 && (cv.pay.get('recipient_filter') == 'all' || cv.pay.get('recipient_filter') == 'teams')){
            team_engine.search(q, function(datums){
              results = _.union(results,datums);
            });
          }
        }

        // Sort them
        results.sort(function(a, b){
          if(a.name < b.name) { return -1; }
          if(a.name > b.name) { return 1; }
          return 0;
        });

        sync(results);
      },
      display: function (datum) {
        return datum.name;
      },
      templates: {
        suggestion: cv.Templates['pay/amount/tt_recipient']
      }
    })
    .on('typeahead:select', _.bind(function(evt, datum){
      console.log(datum);

      this.$('#recipient').blur();

      // Set the proper datum here
      if(datum.type == 'fundraiser'){
        cv.pay.set({
          'project_id' : datum.id,
          'team_id' : null
        });
      }else{
        cv.pay.set({
          'project_id' : null,
          'team_id' : datum.id
        });
      }
    }, this));
  },

  onShow: function(){
    // Bind stickit
    this.stickit(this._model_clone);

    // Another binding
    this.stickit(cv.pay, this.payModelBinding);

    // Click this first tier if we don't have a value
    if(this._model_clone.get('amount') == ''){
      this.$('.tier:visible:eq(0)').click();
    }

    // Bind the recipients
    this.bindRecipients();
  }
});
